import { Button } from 'shared/components/ui';
import React, { useState } from 'react';
import CalendarioView from './CalendarioView';
import HorarioMedicoForm from './HorarioMedicoForm';
import DisponibilidadSemanal from './DisponibilidadSemanal';
import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import { CalendarMonth, EventBusy } from '@mui/icons-material';
import './Calendario.css';

const CalendarioPage = () => {
  const [vista, setVista] = useState('calendario');
  const [horarioSeleccionado, setHorarioSeleccionado] = useState(null);

  const handleNuevoHorarioMedico = () => {
    setHorarioSeleccionado(null);
    setVista('horarioMedico');
  };

  const handleEditarHorario = (horario) => {
    setHorarioSeleccionado(horario);
    setVista('horarioMedico');
  };

  const handleCancelar = () => {
    setHorarioSeleccionado(null);
    setVista('calendario');
  };

  const handleGuardar = () => {
    setHorarioSeleccionado(null);
    setVista('calendario');
  };

  return (
    <div className="calendario-page">
      <Header />
      <div className="main-content">
        {vista === 'calendario' && (
          <>
            <div className="page-header">
              <h2 className="page-title-grilla">
                <CalendarMonth sx={{ fontSize: 32, mr: 1, verticalAlign: 'middle', color: '#6d1212' }} />
                Calendario de Horarios Médicos
              </h2>
              <span className="page-subtitle">Gestión de horarios y disponibilidad</span>
            </div>
            <div style={{ marginBottom: '15px' }}>
              <Button type="button" className="btn btn-warning" onClick={() => setVista('disponibilidadSemanal')}>
                <EventBusy sx={{ fontSize: 18, mr: 0.5 }} />
                Deshabilitar días por semana
              </Button>
            </div>
            <CalendarioView
              onNuevoHorarioMedico={handleNuevoHorarioMedico}
              onEditarHorario={handleEditarHorario}
            />
          </>
        )}
        {vista === 'horarioMedico' && (
          <HorarioMedicoForm
            horario={horarioSeleccionado}
            onCancelar={handleCancelar}
            onGuardar={handleGuardar}
          />
        )}
        {vista === 'disponibilidadSemanal' && (
          <DisponibilidadSemanal onVolver={() => setVista('calendario')} />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CalendarioPage;
